import { handleActions } from 'redux-actions';
import { loop, Cmd } from 'redux-loop';

import historyActions from '../action/history';
import { historyAddCommand, historyLoadCommand } from '../command/history';

export { default as Actions } from '../action/history';

export const base = 'history';

export const defaultState = {
  isListingLoading: false,
  isListingNeedsFetch: true,
  listings: [],
};

export const selectHistoryIsListingLoading = ({ history }) =>
  history.isListingLoading;
export const selectHistoryIsListingNeedsFetch = ({ history }) =>
  history.isListingNeedsFetch;
export const selectHistoryListings = ({ history }) => history.listings;

export default () =>
  handleActions(
    {
      [historyActions.add](state, { payload }) {
        return loop(
          { ...state, isListingLoading: true },
          Cmd.run(historyAddCommand, {
            successActionCreator: historyActions.addSuccess,
            args: [payload],
          })
        );
      },
      [historyActions.addSuccess](state, { payload }) {
        return {
          ...state,
          isListingLoading: false,
          isListingNeedsFetch: false,
          listings: payload.history,
        };
      },
      [historyActions.load](state) {
        return loop(
          { ...state, isListingLoading: true },
          Cmd.run(historyLoadCommand, {
            successActionCreator: historyActions.loadSuccess,
          })
        );
      },
      [historyActions.loadSuccess](state, { payload }) {
        return {
          ...state,
          isListingLoading: false,
          isListingNeedsFetch: false,
          listings: payload.history,
        };
      },
    },
    defaultState
  );
